import { useQuery } from '@tanstack/react-query'
import { practiceApi } from '../api/practice.api'

export const DUE_ITEMS_QUERY_KEY = ['practice', 'due'] as const

/**
 * Items dus pour la répétition espacée de l'utilisateur (SPEC §10, §12,
 * `GET /practice/due`, lot S). `topicIds` restreint aux items de ces topics ;
 * omis, aucun filtre n'est appliqué — tous les items dus sont candidats.
 *
 * `staleTime` court (contrairement à `useGames`/`useDailyLeaderboard`) : le
 * compte affiché par `DueBanner` change dès qu'une partie est terminée
 * (`RunScorer::scheduleReview()` reprogramme chaque item joué), et rester
 * juste après une partie importe plus ici qu'ailleurs dans `practice/`.
 */
export function useDueItems(topicIds?: string[]) {
  return useQuery({
    queryKey: topicIds && topicIds.length > 0 ? [...DUE_ITEMS_QUERY_KEY, topicIds] : DUE_ITEMS_QUERY_KEY,
    queryFn: () => practiceApi.fetchDue(topicIds).then((response) => response.data.data),
    staleTime: 10_000,
  })
}
